<template>
  <Page404 v-if="display404"/>
</template>

<script>
import Page404 from './Page404'

export default {
  name: 'PageResolver',
  components: {
    Page404
  },
  data: function() {
    return {
      display404: false
    }
  },
  mounted() {
    this.$setupComponents().then(data => {
      console.log("DATA", data)
      //this.$router.push("/admin/dashboard")
      if (data[0] == 'componentsDidSetup') {
        let pathParts = this.$route.path.split("/")
        if (this.$route.path.includes("/admin/component/")) {
          let cuuid = pathParts[3]

          let component = data[1].find(c => {
            return c.uuid == cuuid
          })

          if (component === undefined) {
            this.$router.push("")
          }
        }
      }
    }).catch((err) => {
      this.$debugLog(err)
      this.$router.push("")
    })
  }
}
</script>
